<template>
  <div class="column_center_around order_method_container">
    <text class="title">選擇取餐時間</text>
    <div class="w-full h-[56px] mt-5 border border-[#AAAAAA] rounded-md">
      <el-date-picker size="large" v-model="selectedDate" type="date" placeholder="選擇日期" :disabled-date="disabledDate"
        :editable="false"></el-date-picker>
    </div>
    <div class="w-full h-[56px] mt-2 mb-4 border border-[#AAAAAA] rounded-md">
      <el-select id="county-select" v-model="selectedTime" size="large" placeholder="選擇時間">
        <el-option value="選擇時間" selected disabled hidden>選擇時間</el-option>
        <el-option v-for="(item, index) in timeOptions" :value="item" :key="index">
          {{ item }}
        </el-option>
      </el-select>
    </div>
    <text class="title">聯絡電話</text>
    <input inputmode="tel" v-model="phone" class="input" placeholder="輸入聯絡電話" style="text-align: left" maxlength="10" />

    <text class="title">選擇送餐地址</text>

    <div class="row_center_between w-full h-[54px] my-2.5">
      <div class="area_select h-[56px] border border-[#AAAAAA] rounded-md">
        <el-select id="county-select" v-model="selectedCity" size="large" placeholder="縣市">
          <el-option value="選擇縣市" disabled selected hidden>選擇縣市</el-option>
          <el-option v-for="(city, index) in cities" :value="city.id" :key="index" :label="city.name">
          </el-option>
        </el-select>
      </div>


      <div class="area_select h-[56px] border border-[#AAAAAA] rounded-md">
        <el-select id="area-select" v-model="selectedCityArea" size="large" placeholder="區域">
          <el-option value="選擇區域" disabled selected hidden>選擇區域</el-option>
          <el-option v-for="(area, index) in matchedCityAreas" :value="area.id" :key="index" :label="area.name">
          </el-option>
        </el-select>
      </div>
    </div>
    <input class="input" placeholder="輸入地址" style="text-align: left" v-model="inputAddress" />
    <button class="row_center_center commonly_use" @click="openPickAddress">常用地址</button>
    <div class="column_start_start hint">
      <p>消費滿200元，1公里內免費外送。</p>
      <p>未滿200元，加收運費30元。</p>
    </div>

    <button class="button" @click="toOrderPage">開始點餐</button>
    <PickAddressPopup v-if="showPickAddressPopup" @close="closePickAddress" />
  </div>
</template>
<script>
import commonUtilities from "@/utils/common.utils";
import Swal from "sweetalert2";
import areaData from "@/area_data"
import pickAddressPopup from "./pickAddressPopup.vue";
import { dayjs } from 'element-plus';
import {
  mapState,
  mapGetters
} from 'vuex';
export default {
  components: {
    PickAddressPopup: pickAddressPopup,
  },
  data() {
    return {
      selectedDate: "",
      selectedTime: "選擇時間",
      timeOptions: [],
      selectedCity: "選擇縣市",
      selectedCityArea: "選擇區域",
      inputAddress: "",
      matchedCityAreas: [],
      isLoading: true,
      phone: "",
      showPickAddressPopup: false,
      disabledDate: (d) => dayjs(d).isBefore(dayjs().subtract(1, 'day'))
    };
  },
  computed: {
    ...mapState('userData', {
      getToken: 'token',
      memberInfo: 'memberInfo',
    }),
    ...mapGetters('userData', {
      isLogin: 'isLogin'
    }),
    ...mapState('basic', {
      getSelectedAddressData: 'selectedAddressData',
      currentStore: 'currentStore',
      cities: 'cities',
      cityAreas: 'cityAreas',
    }),
    getDefaultAddressData() {
      const addresses = this.memberInfo.addresses;
      if (!addresses.length) {
        return {}
      }
      const defaultAddress = this.memberInfo.addresses.find((address) => {
        address.is_default === 1
      })
      return defaultAddress || addresses[0]
    },
  },
  watch: {
    isLoading(state) {
      if (!state) {
        Swal.clickCancel();
      }
    },
    selectedCity() {
      this.matchedCityAreas = []
      // 在 cityAreas 中找出與 this.selectedCity 相同的 city_id
      for (const cityArea of this.cityAreas) {
        if (cityArea.city_id == this.selectedCity) {
          this.matchedCityAreas.push(cityArea)
        }
      }

      const isCityAreaMatched = this.matchedCityAreas.some((cityArea) => {
        return cityArea.id == this.selectedCityArea
      })
      if (!isCityAreaMatched) {
        this.selectedCityArea = ""
      }
      // this.modifiedAddressData.city_id = this.selectedCity
      console.log('selectedCity', this.selectedCity)
    },
    selectedCityArea() {
      // this.modifiedAddressData.cityarea_id = this.selectedCityArea
      console.log('selectedCityArea', this.selectedCityArea)
      const postcode = areaData[this.selectedCityArea]
      // this.modifiedAddressData.postcode = postcode
      console.log('郵遞區號', postcode)
    },
    getSelectedAddressData() {
      this.selectedCity = this.getSelectedAddressData.city_id
      this.selectedCityArea = this.getSelectedAddressData.cityarea_id
      this.inputAddress = this.getSelectedAddressData.address
      this.phone = this.getSelectedAddressData.phone
    }
  },
  async mounted() {
    // 顯示讀loading 彈窗
    // commonUtilities.createLoading("資料讀取中", "請稍後");
    this.initialize()
    const now = new Date()
    const hour = now.getHours()
    for (let i = hour + 1; i <= 23; i++) {
      let time = `${i}:00`;
      this.timeOptions.push(time);
    }
    let suffixIcons = document.getElementsByClassName('el-select__suffix')
    if (suffixIcons.length > 0) {
      for (const el of suffixIcons) {
        el.innerHTML = '<text id="expand_more" class="button-icon" style="color: #FBCB02; font-size: 28px; width: 28px; height: 28px;">expand_more</text>'
      }
    }
  },
  methods: {
    toOrderPage() {
      if (!this.validateForm()) {
        return
      }

      let payment = {}
      // TODO: 需轉成 UTC 時間
      let pickupDate = commonUtilities.convertDate(this.selectedDate)
      payment.pickupDate = pickupDate
      payment.pickupTime = this.selectedTime
      payment.phone = this.phone
      const city = this.cities.find((city) => {
        return city.id == this.selectedCity
      })
      const cityArea = this.cityAreas.find((cityArea) => {
        return cityArea.id == this.selectedCityArea
      })
      console.log(city, cityArea)
      payment.address = city.name + cityArea.name + this.inputAddress
      this.$store.commit("cart/setPayment", payment)
      const data = {
        method: 'delivery'
      }
      this.$store.commit('cart/setTableData', {
        areaId: null,
        tableIndex: -1,
      })
      this.$emit('toOrderPage', data)
    },
    validateForm() {
      if (this.selectedDate === "") {
        commonUtilities.createToast("error", "請選擇取餐日期");
        return false;
      }
      if (this.selectedTime === "選擇時間") {
        commonUtilities.createToast("error", "請選擇取餐時間");
        return false;
      }
      if (this.selectedCity === "") {
        commonUtilities.createToast("error", "請選擇縣市");
        return false;
      }
      if (this.selectedCityArea === "") {
        commonUtilities.createToast("error", "請選擇區域");
        return false;
      }
      if (this.inputAddress === "") {
        commonUtilities.createToast("error", "請輸入地址");
        return false;
      }
      if (this.phone === "") {
        commonUtilities.createToast("error", "請輸入聯絡電話");
        return false;
      }
      return true;
    },
    closePickAddress() {
      this.showPickAddressPopup = false
    },
    openPickAddress() {
      this.showPickAddressPopup = true
    },
    async initialize() {
      try {
        if (!this.isLogin) {
          commonUtilities.createToast("error", "登入狀態已過期，請重新登入");
          await commonUtilities.delay(2000)
          this.$router.push({
            path: `/${this.getCurrentStore}`
          })
          return
        }
        if (!this.cities.length) await this.$store.dispatch('basic/fetchCities')
        if (!this.cityAreas.length) await this.$store.dispatch('basic/fetchCityAreas')
        this.$store.dispatch('userData/fetchMemberInfo')
        console.log('member info', this.memberInfo)
        if (this.memberInfo.addresses.length) {
          console.log('會員有設定預設地址地址', this.getDefaultAddressData)
          this.selectedCity = this.getDefaultAddressData.city_id
          this.selectedCityArea = this.getDefaultAddressData.cityarea_id
          this.inputAddress = this.getDefaultAddressData.address
          this.phone = this.getDefaultAddressData.phone
        }

        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        await commonUtilities.delay(500)
        commonUtilities.createToast('error', error)
        console.log(error)
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.area_select {
  width: 47%;
}

.hint {
  width: 100%;
  line-height: 20px;
  font-size: 14px;
  font-family: PingFang SC;
  color: #fd5001;
  margin-bottom: 15px;
}

.commonly_use {
  width: 100%;
  height: 34px;
  background-color: #DDDDDD;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  color: #000;
  border: none;
  margin-bottom: 10px;
}
</style>
